<template>
 

  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view></router-view>
      </el-main>
      <div class="kerlao">
        <span @click="onClkierr(1)" style="color: #5076CB;"
				>京公网安备11010502053381号</span>
			<span @click="onClkierr(2)"  style="margin-left: 30px; color: #5076CB;">京ICP备2020048669号-3</span>
			<img src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/2849abe8-e9ff-4b6f-8fe1-2a2d78b95df6.png"
				alt="">
      </div>
      <!-- <a href="" target="_blank">京ICP备2020048669号-3</a> -->
    </el-container>

  </el-container>
</template>

<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {
    onClkierr(i){
			if(i==1){
				window.open("https://beian.mps.gov.cn/#/query/webSearch?recordcode=11010502053381")

			}else{
				window.open("https://beian.miit.gov.cn/")
				
			}

		},

    // handleOpen(key, keyPath) {
    //     console.log(key, keyPath);
    //   },
    //   handleClose(key, keyPath) {
    //     console.log(key, keyPath);
    //   }

  },
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  // beforeMount() {
  //   // 弹出登录成功
  //   this.$message({
  //     message: '登录成功',
  //     type: 'success'
  //   })
  // }
}
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
.kerlao{
  width: 100%;
  height: 40px;
  background-color: #1e1c2e;
  text-align: center;
  line-height: 40px;
  position: relative;
}
.kerlao img{
  width: 20px;
	height: 20px;
	position: absolute;
	top: 9px;
	left: 51%;
}
.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 195px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
  /* position: fixed;
  z-index: 999999999; */
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue